module.exports = __webpack_public_path__ + "media/bootstrap-icons/filter-left-957731d6.svg";